module.exports = __webpack_public_path__ + "img/login-img-6.891c3cec.svg";